import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { COLORS } from '../constants';

const IntroOverlay = ({ onFinish }) => {
  const audioRef = useRef(null);

  const [started, setStarted] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [showText, setShowText] = useState(false);

  const finishIntro = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    onFinish();
  };

  const startExperience = () => {
  if (started) return;
  setStarted(true);

  const audio = audioRef.current;
  if (audio) {
    audio.currentTime = 0;
    audio.volume = 1;
    audio.play().catch(() => {
      // Audio autoplay blocked, continue silently
    });
  }

  setTimeout(() => setShowImage(true), 1000);
  setTimeout(() => setShowText(true), 5500);
  setTimeout(() => finishIntro(), 10000);
};

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 z-[9999] bg-black"
      onPointerDown={startExperience}
    >
      <audio
  ref={audioRef}
  src="/audio/intro.mp3"
  preload="auto"
  playsInline
/>

      <button
        onClick={(e) => {
          e.stopPropagation();
          finishIntro();
        }}
        className="absolute top-6 right-6 z-20 px-6 py-2 rounded-full text-xs uppercase tracking-widest font-bold
                   bg-black/50 text-[#F2EBDC] border border-white/20
                   hover:bg-black/70 transition"
      >
        Skip
      </button>

      <AnimatePresence>
        {showImage && (
          <motion.img
            src="images/intro.jpg"
            alt="Lectric Scooter Hero"
            initial={{ opacity: 0, scale: 1.15 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="w-full h-full object-contain"
          />
        )}
      </AnimatePresence>

      {showImage && <div className="absolute inset-0 bg-black/60" />}

      <AnimatePresence>
        {showText && (
          <motion.div
		  initial={{ opacity: 0, y: 60 }}
		  animate={{ opacity: 1, y: 0 }}
		  transition={{ duration: 1.4, ease: "easeOut" }}
		  className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6"
	>
            <h1 className="text-5xl md:text-7xl font-serif font-bold text-[#F2EBDC] mb-6">
              Lectric <span style={{ color: COLORS.accent }}>Leisure</span>
            </h1>
            <p className="text-xl md:text-2xl text-[#F2EBDC] opacity-80">
              Affordable, so you can Follow Your Golfing Dreams!
            </p>
          </motion.div>
        )}
      </AnimatePresence>

      {!started && (
	
        <motion.div
  animate={{ y: [0, -10, 0] }}
  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
  className="absolute inset-0 flex items-center justify-center text-[#F2EBDC] opacity-70 tracking-widest uppercase text-sm"
>
  Tap anywhere to begin
</motion.div>
      )}
    </motion.div>
	
  );
};

export default IntroOverlay;